<template>
    <div @click="displayPrompt" class="px-4 py-4 list-item-component">
        <div class="vx-row">
          <div class="vx-col w-full sm:w-5/6 flex sm:items-center sm:flex-row flex-col">
                <div class="flex items-center">
                    <h5 class="todo-title">{{ taskLocal.title }}</h5>
                </div>
              <div class="todo-tags sm:ml-2 sm:my-0 my-2 flex">
                    <vs-chip v-for="(tag, index) in taskLocal.tags" :key="index">
                        <div class="icondiv" :class="tag.text =='Low' ? 'low' : tag.text =='Medium' ? 'medium': 'high' " ></div>
                        <span>{{ tag.text | capitalize }}</span>
                    </vs-chip>
              </div>
          </div>

            
        </div>
        <div class="vx-row" v-if="taskLocal.description">
            <div class="vx-col w-full">
                <h6 class="mt-2 mb-2 truncate" style="text-align:left;" :class="{'line-through': taskLocal.isCompleted}">{{ taskLocal.description }}</h6>
                <p>{{"Due Date: "+ taskLocal.dueDate}}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default{
  props: {
    taskId: {
      type: Number,
      required: true
    },
    taskLocal:{
      type:Object,
      required: true
    }
  },
  data () {
    return {
      tags:[],
      displayDate:null,
    }
  },
  watch:{
    
  },
  methods: {
    displayPrompt () {
      this.$emit('showDisplayPrompt', this.taskLocal)
    }
  },
}
</script>
<style lang="scss">
  .icondiv{
    width: 0.5rem !important;
    height: 0.5rem !important;
    border-radius: 9999px !important;
    margin-right: 0.25rem !important;
  }

  .low{
    background-color: green;
  }
  .medium{
    background-color: orange;
  }
  .high{
    background-color: red;
  }
</style>